<template>
  <div class="change-info">
    <div class="change-info-item base-info-list">
      <div class="change-item-title">
        变更前信息
      </div>
      <slot name="before" />
    </div>
    <div class="change-info-item base-info-list">
      <div class="change-item-title">
        变更后信息
      </div>
      <slot name="after" />
    </div>
  </div>
</template>
